import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

/* Ana sayfa 3. bandi: zarafet sayfasinin kompakt hali — akan altin kanji + gorsel nehri. */

const KANJI = [
  { k: "健康", meaning: { tr: "Sağlık", en: "Health" } },
  { k: "善", meaning: { tr: "İyilik", en: "Goodness" } },
  { k: "癒", meaning: { tr: "Şifa", en: "Healing" } },
  { k: "和", meaning: { tr: "Uyum", en: "Harmony" } },
  { k: "命", meaning: { tr: "Yaşam", en: "Life" } },
  { k: "心", meaning: { tr: "Kalp", en: "Heart" } },
  { k: "絆", meaning: { tr: "Bağ", en: "Bond" } },
  { k: "未来", meaning: { tr: "Gelecek", en: "Future" } },
];

const RIVER = ["/img/zarafet/onsen.jpg", "/img/zarafet/torii.jpg", "/img/zarafet/garden.jpg", "/img/zarafet/tea.jpg", "/img/zarafet/sakura.jpg", "/img/clinic/c3.jpg"];

export function ZarafetBand() {
  const { lang } = useLang();
  const loc = (m) => m[lang] || m.tr;

  return (
    <section className="relative overflow-hidden bg-[#0A0508] py-14 sm:py-20" data-testid="zarafet-band">
      <span aria-hidden className="absolute -left-6 top-1/2 -translate-y-1/2 font-magserif text-[24vw] leading-none text-[#C9A96A] opacity-[0.05] select-none pointer-events-none hidden lg:block">美</span>

      <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.9 }} className="relative border-y border-[#C9A96A]/15 py-4">
        <Marquee speed={36} direction="left" gradient={false}>
          {KANJI.map((item) => (
            <div key={item.k} className="mx-7 sm:mx-10 flex items-center gap-4 select-none">
              <span className="font-magserif text-5xl sm:text-6xl text-[#C9A96A] leading-none">{item.k}</span>
              <span className="font-serif text-xl sm:text-2xl font-bold text-[#F5EFE6]">{loc(item.meaning)}</span>
            </div>
          ))}
        </Marquee>
      </motion.div>

      <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 1, delay: 0.1 }} className="relative mt-8" data-testid="zarafet-band-river">
        <Marquee speed={28} direction="right" gradient={false} pauseOnHover>
          {RIVER.map((src, i) => (
            <div key={`${src}-${i}`} className="mx-3 rounded-2xl p-[2px] bg-[linear-gradient(140deg,#C9A96A_0%,#6e5522_45%,#C9A96A_65%,#8a6b2f_100%)] shadow-[0_24px_50px_-18px_rgba(0,0,0,0.8)]">
              <img src={src} alt="" loading="lazy" draggable={false} className="h-44 sm:h-60 w-auto rounded-[calc(1rem-2px)] object-cover select-none" />
            </div>
          ))}
        </Marquee>
      </motion.div>

      <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.2 }} className="relative mt-8 text-center">
        <Link data-testid="zarafet-band-link" to="/zarafet" className="inline-flex items-center gap-2 text-sm font-semibold text-[#C9A96A] hover:text-[#dfc08a] transition-colors">
          {lang === "tr" ? "Japon Zarafeti'ni keşfedin" : "Explore Japanese Grace"} <ArrowRight size={15} />
        </Link>
      </motion.div>
    </section>
  );
}
